import { render, staticRenderFns } from "./DashboardMeetingDetails.vue?vue&type=template&id=0c0df907"
import script from "./DashboardMeetingDetails.vue?vue&type=script&lang=js"
export * from "./DashboardMeetingDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports